import { render } from "./WorkEdit.vue?vue&type=template&id=70122c44"
import script from "./WorkEdit.vue?vue&type=script&lang=js"
export * from "./WorkEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__